// extracted by mini-css-extract-plugin
export default {"add-branch-modal":"branch-name-modal_add-branch-modal__BsCFf","add-branch-modal__input-section":"branch-name-modal_add-branch-modal__input-section__vYMP2"};